
  import { Vue, Prop, Component } from "vue-property-decorator";


  @Component
  export default class ColorIconContainer extends Vue {
    @Prop({type: Boolean, default: false}) readonly iconStyle!: boolean;

    get iconClass(): string {
      return this.iconStyle ? "emailIcon" : "documentIcons";
    }
  }
